import React, { useEffect, useState } from "react";
import "./SettlementReport.css";
import { useSelector } from "react-redux";
import { getTotalProviderSettlement } from "../../../config/LiveApi";
import { FcMoneyTransfer } from "react-icons/fc";
import Modal from "./ModalPaid";
import Pagination from "./Pagination";
import DownloadReportModal from "../downloadReport/Modal";
import DateFilter from "../../../components/common/DateFilter";

import DataTable from "../../../components/common/DataTable/DataTable";
import DateCell from "../../../components/common/TableCells/DateCell";

const SettlementTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const userId = useSelector((store) => store.userReducer.userId);

  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState({ data: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    data: null,
  });

  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const allowedUsers = JSON.parse(
    import.meta.env.VITE_SETTLEMENT_PAY_USERS || "[]"
  );

  const isPayAmountAllowed =
    import.meta.env.VITE_APP_ENV === "local" &&
    allowedUsers.includes(userId);

  const getSettlementData = async (start = startDate, end = endDate) => {
    setLoading(true);

    try {
      const response = await getTotalProviderSettlement(
        token,
        currentPage,
        start,
        end
      );

      setTableData(response.data);
      setTotalPages(response.data.totalPages);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      getSettlementData();
    }
  }, [token, currentPage, startDate, endDate]);

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    getSettlementData(start, end);
  };

  const columns = [
    {
      header: "Provider Name",
      accessor: "providerName",
      render: (row) => row?.providerName || '-',
    },
    {
      header: "Late Settlement",
      accessor: "lateSettlement",
      render: (row) => `₹ ${Number(row?.lateSettlement || 0).toFixed(2)}`,
    },
    {
      header: "On Time Settlement",
      accessor: "onTimeSettlement",
      render: (row) => `₹ ${Number(row?.onTimeSettlement || 0).toFixed(2)}`,
    },
    {
      header: "Total Settlement Amount",
      render: (row) =>
        `₹ ${Number(
          (row?.lateSettlement || 0) + (row?.onTimeSettlement || 0)
        ).toFixed(2)}`,
    },
    {
      header: "Settlement Time Range",
      accessor: "settlementTimeRange",
       render: (row) => row?.settlementTimeRange || '-',
    },
    {
      header: "Paid Amount",
      render: (row) => `₹ ${row?.paidAmount || 0}`,
    },
    {
      header: "Settled Date",
      render: (row) => <DateCell date={row.settledDate} />,
    },
    ...(isPayAmountAllowed
      ? [
          {
            header: "Pay Amount",
            render: (row) => (
              <FcMoneyTransfer
                size={25}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setIsModalOpen({
                    open: true,
                    data: row,
                    paidAmount:
                      (row?.lateSettlement || 0) +
                      (row?.onTimeSettlement || 0),
                  })
                }
              />
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="provider-settlement-report-container">
        <div className="provider-table-head">
          <div className="provider-settlement-report-title">
            Total Provider Settlement
          </div>
        </div>

        <DateFilter onDateChange={handleDateChange} />

        <div className="provider-settlement-report-title">
          <button
            className="button-download-ps"
            onClick={() => setIsDownloadModalOpen(true)}
          >
            Download Report
          </button>
        </div>

        <DataTable
          columns={columns}
          data={tableData?.data || []}
          loading={loading}
          emptyMessage="No Data Found"
          rowClassName={(row) =>
            row?.paidAmount <= 0 ? "highlight-row-red" : ""
          }
        />

        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

      {isModalOpen.open && (
        <Modal
          onClose={() => setIsModalOpen({ open: false, data: null })}
          reportData={isModalOpen.data}
          paidAmount={isModalOpen.paidAmount}
          refreshTableData={getSettlementData}
        />
      )}

      {isDownloadModalOpen && (
        <DownloadReportModal
          onClose={() => setIsDownloadModalOpen(false)}
        />
      )}
    </>
  );
};

export default SettlementTable;